/*
 *  -----------------------------------------------------------------------
 *    <copyright file="edit-multiple-fields-modal.constants.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { getFieldsAndDataSources_OpraQueries_fields_FieldDefinition } from '@queries/generated/central-monitoring.generated';

export const fieldsPack = {
    visits: [
        { id: 'active', name: 'Active', active: true },
        { id: 'type', name: 'Visit Type', active: true },
        { id: 'minOccurrences', name: '# of Occurrences', active: true },
        { id: 'leadVisitId', name: 'Lead Visit ID', active: true },
        { id: 'leadPeriod', name: 'Lead Time', active: true },
        { id: 'leadUnit', name: 'Lead Unit', active: true },
        { id: 'minWinPeriod', name: 'Min. Win. Time', active: true },
        { id: 'maxWinPeriod', name: 'Max. Win. Time', active: true },
        { id: 'minWinUnit', name: 'Min. Max. Unit', active: true },
        { id: 'endDateUsage', name: 'End Date Usage', active: true },
        { id: 'forecastEndDate', name: 'Forecast End Date', active: true },
    ],
};

export const fieldsExclusionValidationArray = ['active', 'leadVisitId'];

interface initialVisitFields {
    [key: string]: any;
    active: boolean | string;
    type: string;
    leadVisitId: string;
    leadPeriod: number | null;
    leadUnit: string;
    minWinPeriod: number | null;
    maxWinPeriod: number | null;
    minWinUnit: string;
    minOccurrences: number;
    forecastEndDate: getFieldsAndDataSources_OpraQueries_fields_FieldDefinition[];
    endDateUsage: string;
}

interface initialsFieldsState {
    visits: initialVisitFields;
}

export const initialsFieldsStatePack: initialsFieldsState = {
    visits: {
        active: 'true',
        type: '' as string,
        leadVisitId: '',
        leadPeriod: 0,
        leadUnit: 'NONE' as string,
        minWinPeriod: 0,
        maxWinPeriod: 0,
        minWinUnit: 'NONE' as string,
        minOccurrences: 1,
        forecastEndDate: [] as any,
        endDateUsage: '',
    },
};
export const initialFieldsErrors = {
    active: '',
    type: '',
    leadVisitId: '',
    leadUnit: '',
    leadPeriod: '',
    minWinPeriod: '',
    maxWinPeriod: '',
    minWinUnit: '',
    minOccurrences: '',
    forecastEndDate: '',
    endDateUsage: '',
};
